import React from 'react';
import { Button, Space } from 'antd';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const shake = keyframes`
  0%, 100% { transform: translateX(0); }
  25% { transform: translateX(-5px); }
  75% { transform: translateX(5px); }
`;

const StyledOverlay = styled.div<{ type: 'correct' | 'wrong' | 'complete' | null }>`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  animation: ${fadeIn} 0.3s ease-out;
  background: ${props => {
    switch (props.type) {
      case 'wrong':
        return 'transparent';
      case 'correct':
        return 'transparent';
      case 'complete':
        return 'rgba(0, 0, 0, 0.6)';
      default:
        return 'transparent';
    }
  }};
`;

const IconWrapper = styled.div<{ type: 'correct' | 'wrong' }>`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: white;
  display: flex;
  justify-content: center;
  align-items: center;
  animation: ${props => props.type === 'wrong' ? shake : fadeIn} 0.3s ease-out;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
`;

interface OverlayProps {
  type: 'correct' | 'wrong' | 'complete' | null;
  onClose: () => void;
  onContinue?: () => void;
  onReturn?: () => void;
  continueText?: string;
  isGameCompleted?: boolean;
}

const Overlay: React.FC<OverlayProps> = ({ 
  type, 
  onClose, 
  onContinue, 
  onReturn,
  continueText = "继续练习",
  isGameCompleted = false
}) => {
  return (
    <StyledOverlay 
      type={type} 
      onClick={type !== 'complete' ? onClose : undefined}
    >
      {type === 'correct' ? (
        <div className="absolute inset-0 flex items-center justify-center">
          <IconWrapper type="correct">
            <CheckOutlined style={{ fontSize: '48px', color: '#52c41a' }} />
          </IconWrapper>
        </div>
      ) : type === 'wrong' ? (
        <div className="absolute inset-0 flex items-center justify-center">
          <IconWrapper type="wrong">
            <CloseOutlined style={{ fontSize: '48px', color: '#ff4d4f' }} />
          </IconWrapper>
        </div>
      ) : type === 'complete' ? (
        <div className="absolute inset-0 flex items-center justify-center bg-black/50">
          <Space direction="vertical" size="large" align="center">
            <div style={{ 
              fontSize: '24px', 
              color: '#fff', 
              textAlign: 'center',
              fontWeight: 'bold',
              textShadow: '0 2px 4px rgba(0,0,0,0.2)'
            }}>
              {isGameCompleted ? "恭喜你完成该棋谱！" : "恭喜你完成该变化！"}
            </div>
            <Space size="middle">
              <Button type="primary" size="large" onClick={onContinue}>
                {continueText}
              </Button>
              <Button size="large" onClick={onReturn}>
                返回列表
              </Button>
            </Space>
          </Space>
        </div>
      ) : null}
    </StyledOverlay>
  );
};

export default Overlay; 